module.exports = __webpack_public_path__ + "img/man_2_2.fd507c7d.png";